/**
 * aramScale — Murder Bridge proportions from LoL units → sandbox.
 * Champion size is FIXED in sandbox; bridge scales by rule of three.
 *
 * Sources:
 * - Champion gameplay radius ≈ 65 → diameter 130 ([Unit size](https://wiki.leagueoflegends.com/en-us/Unit_size); Ashe)
 * - Proving Grounds S2: lane width 2600, bridge length 18000 (docs/maps_and_structures)
 * - Modern HA lane width ≈ 1700 (wiki Lanes) — not used; project targets S2 Proving Grounds
 *
 * Rule of three (sandboxChamp fixed):
 *   sandboxDim = lolDim * (SANDBOX_CHAMP_DIAMETER / LOL_CHAMP_DIAMETER)
 */

/** LoL engine: standard humanoid gameplay diameter (Ashe/Garen ≈ radius 65). */
export const LOL_CHAMP_DIAMETER = 130;

/** Proving Grounds / Murder Bridge lane width (S2 spec). */
export const LOL_ARAM_LANE_WIDTH = 2600;

/** Bridge length spawn-to-spawn along the lane (S2 spec). */
export const LOL_ARAM_BRIDGE_LENGTH = 18000;

/**
 * Fixed sandbox champion footprint diameter.
 * Matches Ashe visual torso (~1.3) and collision radius/16 for radius=20 (=1.25→Ø2.5);
 * 1.5 is the anchored visual/gameplay compromise — do not change when scaling the map.
 */
export const SANDBOX_CHAMP_DIAMETER = 1.5;

export const ARAM_UNIT_SCALE = SANDBOX_CHAMP_DIAMETER / LOL_CHAMP_DIAMETER;

export const ARAM_BRIDGE_WIDTH = LOL_ARAM_LANE_WIDTH * ARAM_UNIT_SCALE;
export const ARAM_BRIDGE_LENGTH = LOL_ARAM_BRIDGE_LENGTH * ARAM_UNIT_SCALE;

/** Half-length along lane (origin at mid). */
export const ARAM_HALF_LENGTH = ARAM_BRIDGE_LENGTH / 2;

/** Scale a LoL engine distance into sandbox units. */
export function lolToSandbox(lolUnits) {
  return lolUnits * ARAM_UNIT_SCALE;
}
